export default __webpack_public_path__ + "static/media/etc-logo3.1bab422a.png";